import { cn } from "~/lib/utils"

function Kbd({
	className,
	variant = "default",
	...props
}: React.ComponentProps<"kbd"> & { variant?: "default" | "plain" }) {
	return (
		<kbd
			data-slot="kbd"
			className={cn(
				"inline-flex h-6 min-w-6 items-center justify-center rounded border border-stroke bg-background-tertiary px-1.5 font-mono text-[11px] font-medium text-text-main shadow-sm",
				"[&_svg:not([class*='size-'])]:size-3",
				"in-data-[slot=tooltip-content]:bg-background/20 in-data-[slot=tooltip-content]:text-background dark:in-data-[slot=tooltip-content]:bg-background/10",
				variant === "plain" &&
					"border-0 bg-transparent text-text-small shadow-none",
				className
			)}
			{...props}
		/>
	)
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<kbd
			data-slot="kbd-group"
			className={cn("inline-flex items-center gap-1", className)}
			{...props}
		/>
	)
}

function KeySequence({
	keys,
	sequence = false
}: {
	keys: string
	sequence?: boolean
}) {
	return (
		<KbdGroup>
			{keys.split(sequence ? " " : "+").map((key, index) => (
				<span key={index} className="inline-flex items-center gap-1">
					{index > 0 && !sequence && (
						<span className="text-xs text-text-small">+</span>
					)}
					<Kbd>{key}</Kbd>
				</span>
			))}
		</KbdGroup>
	)
}

export { KeySequence, Kbd, KbdGroup }
